import React from 'react';
import type { Operation, ColumnOption } from './types.ts';
import { OperationBuilder } from './OperationBuilder.tsx';
import styles from './styles.less';

interface GfqlBuilderProps {
  operations: Operation[];
  columnOptions: ColumnOption[];
  findMatchingColumn: (attributeName: string) => ColumnOption | undefined;
  operatorsByDataType: Record<string, Array<{ label: string; value: string }>>;
  onOperationChange: (operationIndex: number, field: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onConditionChange: (operationIndex: number, conditionIndex: number, field: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onCaseSensitiveChange: (operationIndex: number, conditionIndex: number, e: React.ChangeEvent<HTMLInputElement>) => void;
  onAddCondition: (operationIndex: number) => void;
  onRemoveCondition: (operationIndex: number, conditionIndex: number) => void;
  onAddOperation: () => void;
  onRemoveOperation: (operationIndex: number) => void;
}

export const GfqlBuilder: React.FC<GfqlBuilderProps> = ({
  operations,
  onAddOperation,
  ...operationBuilderProps
}) => {
  return (
    <div className={styles['query-builder']}>
      {operations.map((operation, operationIndex) => (
        <OperationBuilder
          key={operationIndex}
          operation={operation}
          operationIndex={operationIndex}
          operationsCount={operations.length}
          {...operationBuilderProps}
        />
      ))}
      <button type="button" className={styles['add-operation']} onClick={onAddOperation}>
        + Add Operation
      </button>
    </div>
  );
};
